import React from 'react';
import './About.css';
import Skill from './Skill';
function About() {
  return (
    <div className="container" id="about">
      <div className="row">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <h1 className="text-center">About Me</h1>
          <div className="about__border"></div>
          <p className="mt-5 text-justify">
            Hello! I am <span className="about--color">Anum Mujahid</span> and I
            have always been passionate about coding and creating web
            applications efficient in functionality and having user-friendly
            designs. I am a software engineer, web developer, problem solver,
            MERN Stack Developer. I have diverse set of skills, ranging from
            design to frontend to backend development.
          </p>
          <p className="mb-5 text-justify">
            Here are a few technologies, I have been working with recently:
          </p>
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
      <div className="row mb-5 flex" style={{justifyContent: 'center'}}>
          <img
            src="https://img.icons8.com/color/480/000000/mongodb.png"
            alt="mongodb"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/react-native.png"
            alt="react"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/nodejs.png"
            alt="nodejs"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/javascript--v1.png"
            alt="javascript"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/redux.png"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/material-ui.png"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/tailwindcss.png"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/npm.png"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/git.png"
            alt="git"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/material-outlined/384/000000/github.png"
            alt="github"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/firebase.png"
            alt="firebase"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/fluency/240/000000/python.png"
            alt="python"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/c-plus-plus-logo.png"
            alt="C++"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/bootstrap.png"
            alt="bootstrap"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/css3.png"
            alt="css3"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/html-5--v2.png"
            alt="html"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/adobe-illustrator--v1.png"
            alt="adobeillustrator"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/color/480/000000/figma--v1.png"
            alt="figma"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/dusk/480/000000/php-logo.png"
            alt="php"
            width="40"
            height="40"
          />
          <img
            src="https://img.icons8.com/fluency/480/000000/mysql-logo.png"
            alt="mysql"
            width="40"
            height="40"
          />
      </div>
      {/* <div className="row my-5">
        <Skill
          icon="fab fa-react"
          name="React"
          progress="75"
          width="75%"
          color="#489fb5"
        />
        <Skill
          icon="fab fa-node-js"
          name="Node Js"
          progress="75"
          width="75%"
          color="#ed1c24"
        />
        <Skill
          icon="fab fa-envira"
          name="Mongodb"
          progress="75"
          width="75%"
          color="#ff784f"
        />
        <Skill name="Express js" progress="75" width="75%" color="#ffbf00" />
        <Skill
          icon="fab fa-js-square"
          name="Javascript"
          progress="75"
          width="75%"
          color="#ff206e"
        />
        <Skill
          icon="fab fa-css3-alt"
          name="CSS3"
          progress="90"
          width="90%"
          color="#679436"
        />
        <Skill
          icon="fab fa-html5"
          name="Html5"
          progress="90"
          width="90%"
          color="#044389"
        />
        <Skill
          icon="fab fa-git-alt"
          name="Git"
          progress="70"
          width="70%"
          color="#d87cac"
        />
      </div> */}
      <div className="container" id="experience">
        <h1 className="text-center" style={{marginTop: '5rem'}}>Experience</h1>
        <div className="about__border"></div>
        <div className="row my-5">
          <div className="col-12 col-md-2"></div>
          <div className="col-12 col-md-8">
            <div className="accordion" id="accordionExample">
              <div className="card">
                <div className="card-header" id="headingOne">
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Hactric Solutions, Islamabad
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseOne"
                  className="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div className="about__card">
                    <div className="card-body">
                      <h5>MERN Stack Development</h5>
                      <p>August 2021 - October 2021</p>
                      <p>
                        Working as MERN Stack Developer Intern for an internship
                        period of three months as part of project on demand
                        team.
                        <p>Technologies Used:</p>
                        <ul>
                          <li>Mongodb</li>
                          <li>Express</li>
                          <li>Reactjs</li>
                          <li>Nodejs</li>
                          <li>REDUX</li>
                          <li>Git/GitHub (for version control)</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingTwo">
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="true"
                      aria-controls="collapseTwo"
                    >
                      Build Guild, Lahore
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseTwo"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div className="about__card">
                    <div className="card-body">
                      <h5>Front End Development</h5>
                      <p>April 2021 - June 2021</p>
                      <p>
                        Software Construction Semester Project, in which I
                        worked on front end development of Build Guild Web
                        Portal which could track their sales and keep a log of
                        every aspect of their business.
                        <p>Technologies Used:</p>
                        <ul>
                          <li>Html5, CSS3, Javascript</li>
                          <li>AnyChart.js</li>
                          <li>Bootstrap4</li>
                          <li>Jquery</li>
                          <li>Git/GitHub (for version control)</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="card">
                <div className="card-header" id="headingThree">
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Side Projects
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThree"
                  className="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <h5>MERN Stack Development</h5>
                    <p>May 2020 - Present</p>
                    <p>
                      Worked on several side projects using MERN Stack -
                      MongoDB, Express, React, Node JS as well as REDUX which
                      can be found on github.
                      <p>Some of the projects are:</p>
                      <ul>
                        <li>React Netflix Clone</li>
                        <li>React Spotify Clone</li>
                        <li>MERN Whatsapp Clone</li>
                        <li>MERN Recipe Sharing App - Doc's Kitchen</li>
                        <li>MERN Ecommerce App</li>
                        <li>MERN Blog App</li>
                        <li>React Covid 19 Tracker</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="card">
                <div className="card-header" id="headingFour">
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Ibnemujahid Associates and Engineers, Faisalabad
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFour"
                  className="collapse"
                  aria-labelledby="headingFour"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <h5>Web Development</h5>
                    <p>January 2021 - February 2021</p>
                    <p>
                      Worked on portfolio website for the construction company
                      to help them display their projects and reach out their
                      clients easily.
                      <p>Technologies Used:</p>
                      <ul>
                        <li>Html5</li>
                        <li>CSS3</li>
                        <li>Javascript</li>
                        <li>Jquery</li>
                        <li>Bootstrap 4</li>
                        <li>Firebase for Deployment</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="card">
                <div className="card-header" id="headingFive">
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      NUST, Islamabad
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFive"
                  className="collapse"
                  aria-labelledby="headingFive"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <h5>Software Development</h5>
                    <p>September 2018 - Present</p>
                    <p>
                      Experience working on multiple softwrae projects for the
                      degree courses.
                      <p>
                        Some of the projects are:
                        <ul>
                          <li>Voyage</li>
                          <li>Patientio</li>
                          <li>IDOCtify</li>
                        </ul>
                      </p>
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="col-12 col-md-2"></div>
        </div>
      </div>
    </div>
  );
}

export default About;
